module.exports = __webpack_public_path__ + "img/report_pic10.63a87007.png";